import commonApi from './CommonApi.js';
var qs = require('querystring');

export default {
	getForTreeSelect: async (parameter) => {
		return await commonApi().get('/v1/hsProducts/getForTreeSelect', 
			{ 
				params: parameter
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getNotificationHSProducts: async (parameter) => {
		return await commonApi().get('/v1/hsProducts/getNotificationHSProducts', {
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getHSProductInterpreted: async (parameter) => {
		return await commonApi().get('/v1/hsProducts/getHSProductInterpreted',
				{
					params: parameter,
					paramsSerializer: (params) => {
						return qs.stringify(params);
					}
				})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
}